// extracted by mini-css-extract-plugin
export default {"list":"VideoList_list__l5Cv2"};